import styled from 'styled-components'
import { belowPhone } from 'utilities/styled'
import { BottomContainerInner } from 'utilities/panel'
import ShortcutBase from 'components/tiptap/help/shortcut'

export const Container = styled(BottomContainerInner)`
    grid-template-columns: repeat(2, minmax(min-content, auto));
    align-items: center;
    justify-content: space-between;
    column-gap: 40px;

    max-width: var(--content-max-width);
    padding: 16px 40px;
    background-color: var(--huma-color-surface-constructive-bold);

    transition: max-width .15s ease-in-out;

    p {
        color: var(--huma-color-foreground-on-bold);
    }

    ${belowPhone`
        display: flex;
        flex-direction: column;
        row-gap: 16px;

        padding: 16px;
    `}
`

export const Actions = styled.div`
    display: flex;
    column-gap: 24px;
`

export const Info = styled.div`
    display: flex;
    column-gap: 16px;
    align-items: center;

    > .line-adjust {
        margin-block-start: -3px;
    }
`

export const Shortcut = styled(ShortcutBase)`
    display: inline-grid;

    color: var(--huma-color-foreground-default);
`